import React, { Component, Fragment } from 'react'
import {
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
} from 'reactstrap'
import { InputNumber, Checkbox } from 'antd'
import { compose } from 'redux'
import { connectResource } from '../../common/utils/resource'
import { connect } from 'react-redux'
import { CURRENCY_FORMATTER, CURRENCY_PARSER } from '../../common/utils/fees'


class EditVendorFeeOverrideModal extends Component {
    state = {
      enabled: this.props.vendorFeeOverrideDollars != null,
      vendorFeeOverride: this.props.vendorFeeOverrideDollars != null
        ? this.props.vendorFeeOverrideDollars
        : 0,
      isUpdatingFee: false,
    }

    onEnabledChange = (e) => {
      this.setState({ enabled: e.target.checked })
    }

    onChange = (value) => {
      this.setState({ vendorFeeOverride: value })
    }

    onBlur = () => this.setState((state) => {
      const { vendorFeeOverride } = state
      return {
        vendorFeeOverride: (
          vendorFeeOverride && vendorFeeOverride > 0 ? parseFloat(vendorFeeOverride) : 0
        ).toFixed(2),
      }
    })

    onSubmit = () => {
      this.setState({ isUpdatingFee: true })
      const payload = this.state.enabled
        ? { vendor_fee_override: Math.round(this.state.vendorFeeOverride * 100) }
        : { vendor_fee_override: null }
      this.props.vendorFeeOverrideApi
        .put(payload)
        .then(() => this.props.refreshOrder())
        .finally(() => this.setState({ isUpdatingFee: false }))
    }

    render() {
      return <Fragment>
        <ModalHeader>Edit Vendor Fee Override</ModalHeader>
        <ModalBody>
          <Row className='mt-1 mb-2'>
            <Col sm={12} className='mb-3'>
              <Checkbox
                checked={this.state.enabled}
                onChange={this.onEnabledChange}
              >
                Enable vendor fee override
              </Checkbox>
            </Col>
          </Row>
          {this.state.enabled && (
            <Row className='mb-1'>
              <Col sm={4}>
                <b>Vendor Fee</b>
              </Col>
              <Col sm={8}>
                <InputNumber
                  data-testid='vendorFeeOverrideInput'
                  value={this.state.vendorFeeOverride}
                  onChange={(value) => this.onChange(value)}
                  onBlur={this.onBlur}
                  disabled={this.state.isUpdatingFee}
                  formatter={CURRENCY_FORMATTER}
                  parser={CURRENCY_PARSER}
                  style={{ width: 100 }}
                  min={0}
                />
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.props.onHide}>Cancel</Button>
          <Button color='primary' onClick={this.onSubmit} disabled={this.state.isUpdatingFee}>Save</Button>
        </ModalFooter>
      </Fragment>
    }
}


export default compose(
  connect((_state, props) => ({ orderId: props.orderId })),
  connectResource({
    namespace: 'vendorFeeOverrideApi',
    endpoint: 'fee/order/:orderId/vendor-fee-override',
    prefetch: false,
    apiVersion: 2,
    successMessage: { PUT: 'Your vendor fee override has been saved.' },
  }),
)(EditVendorFeeOverrideModal)
